<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <!--{{listData}}-->
        <div class="row align-items-center justify-content-between">
          <div class="col-lg-10 col-12 row pr-0">
            
            <div class="col-lg-4 col-12 pr-0">
                <label class="p-col-fixed txt-left p-0 m-0">Trang trại</label>
                <div class="p-col p-0 pt-1">
                  <Dropdown class="col-12" v-model="farm" :options="farmOptions" optionLabel="name" placeholder="Tất cả" :showClear="true"/>
                </div>
            </div>

            <div class="col-lg-4 col-12 pr-0">
                <label class="p-col-fixed txt-left p-0 m-0">Thời gian</label>
                <div class="p-col p-0 pt-1">
                  <Calendar v-model="dateReport" placeholder="DD/MM/YYYY - DD/MM/YYYY" class="w-100" appendTo="body" :showButtonBar="true" selectionMode="range" dateFormat="dd/mm/yy" :showIcon="true"/>
                </div>
            </div>

            <div class="col-lg-4 col-12 pr-0">
                <label class="p-col-fixed txt-left p-0 m-0">Chủng Loại</label>
                <div class="p-col p-0 pt-1">
                  <Dropdown class="col-12" v-model="kind" :options="kindOptions" optionLabel="name" placeholder="Tất cả" :showClear="true"/>
                </div>
            </div>

          </div>
        </div>
        <BlockTotal :data.sync="total_report" :loading.sync="totalLoading"/>

        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :count="count"
          :loading.sync="localLoading"
          :filterDefault.sync="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onDataChange = 'DataOnChange'
          @getFilters="getFilters"
        ></BaseDatatable>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseDatatable from './list'
import BlockTotal from '@/components/blockTotal'
import ApiRepository from "@/core/ApiRepository";
export default {
  components: {
    BaseDatatable,
    BlockTotal
  },
  data() {
    return {
      total_report: [
        {
          label: 'Tổng số lượng xuất',
          value: 0
        },
        {
          label: 'Tổng TL xuất (kg)',
          value: 0
        },
        {
          label: 'Tổng chết nuôi',
          value: 0
        },
        {
          label: 'Tổng TL chết nuôi (kg)',
          value: 0
        },
        {
          label: 'Tổng nhập',
          value: 0
        },
        {
          label: 'Tổng TL nhập (kg)',
          value: 0
        },
        {
          label: 'Tổng chết vận chuyển',
          value: 0
        },
        {
          label: 'Tổng TL chết vận chuyển (kg)',
          value: 0
        }
      ],
      count: 0,
      filters: {},
      loading: false,
      totalLoading: false,
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      farmOptions: [],
      dateReport: null,
      farm: null,
      localLoading: false,
      kind: null,
      kindOptions: [],
    }
  },
  mounted () {
    this.initParams();
  },
  watch: {
    '$route': 'initParams',
    "dateReport" : {
      async handler()
      {
        // this.loading = true;
        if (!this.$commonFuction.isEmpty(this.dateReport) && !this.$commonFuction.isEmpty(this.dateReport[0]) && !this.$commonFuction.isEmpty(this.dateReport[1])) {
          this.$set(this.filters, 'created_at_filter', {value: this.dateReport, type_input: 'DateRange'});
        } else {
          // console.log(this.dateReport);
          this.$delete(this.filters, 'created_at_filter');
        }
        if (!this.totalLoading) {
          this.getData();
        }
        return;
      }
    },
    "farm"() {
        if (this.farm?.id) {
            this.$set(this.filters, 'farm_id', {value: this.farm?.id, type_input: 'select'});
        } else {
            this.$delete(this.filters, 'farm_id');
        }
        if (!this.totalLoading) {
          this.getData();
        }
        return;
    },
    "kind"() {
        if (this.kind?.id) {
            this.$set(this.filters, 'type_id', {value: this.kind?.id, type_input: 'select'});
        } else {
            this.$delete(this.filters, 'type_id');
        }
        if (!this.totalLoading) {
          this.getData();
        }
        return;
    },
    loading: {
      immediate: true,
      handler(newVal) {
        this.localLoading = newVal;
      }
    }
  },
  async created() {
    await this.getListFarm();
    await this.getListKind();
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    this.title = this.dataModel.label; // Ensure title is set to the label
  },
  methods: {
    getFilters(filters) {
        // console.log("filters.filters", filters.filters);
        this.filters = Object.assign({...this.filters, ...filters?.filters});
        this.first = filters.first;
        this.rows = filters.rows;
        if (!this.totalLoading) {
          return this.getData();
        }
        return;
    },
    async getData() {
      this.localLoading = true;
      var headers = {
        "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
      }
      
      var filter = {};
      if (this.filters) {
        // console.log("this.filtersthis.filtersthis.filters", this.filters);
        for (const [key, value] of Object.entries(this.filters)) {
          filter[key] = value.value;
        }
      }
      try {
        const res = await ApiRepository.post("_api/import_export/history_check", {filters: filter, first: this.first, rows: this.rows}, {headers});
        const {data} = res;
        this.listData = data?.data?.list || [];
        this.listData.weight_die = this.listData.kind_weight * this.listData.number_die
        this.count = data?.data?.count || 0;
        this.total_report = data?.data?.report || [
          {
            "label": "Tổng số lượng xuất",
            "value": 0
          },
          {
            "label": "Tổng TL xuất (kg)",
            "value": 0
          },
          {
            "label": "Tổng chết nuôi",
            "value": 0
          },
          {
            "label": "Tổng TL chết nuôi (kg)",
            "value": 0
          },
          {
            "label": "Tổng nhập",
            "value": 0
          },
          {
            "label": "Tổng TL nhập (kg)",
            "value": 0
          },
          {
            "label": "Tổng chết vận chuyển",
            "value": 0
          },
          {
            "label": "Tổng TL chết vận chuyển (kg)",
            "value": 0
          }
        ];
      } catch (error) {
        console.log('error', error);
        this.$toast.add({
          severity: 'error',
          summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
          detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
          life: 3000
        });
      } finally {
        this.localLoading = false;
      }
    },
    async getListFarm() {
      var gqLQueryList = DataServices.getList("farm", {"fields": "id, name"});
      var where = {
          active: {_eq: true}
      }
      try {
        var resData = await this.$apollo.mutate({
          mutation: gqLQueryList,
          variables: {
            where_key: where,
            orderBy: { created_at: "desc" },
          },
        });
        var listData = resData.data["farm"];
        this.farmOptions = listData;
      } catch (error) {
        console.log('error', error);
        this.$toast.add({
          severity: 'error',
          summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
          detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
          life: 3000
        });
      }
    },
    async getListKind() {
      var gqLQueryList = DataServices.getList("kind_type", {"fields": "id, name"});
      var where = {
          active: {_eq: true}
      }
      try {
        var resData = await this.$apollo.mutate({
          mutation: gqLQueryList,
          variables: {
            where_key: where,
            orderBy: { created_at: "desc" },
          },
        });
        var listData = resData.data["kind_type"];
        this.kindOptions = listData;
      } catch (error) {
        console.log('error', error);
        this.$toast.add({
          severity: 'error',
          summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
          detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
          life: 3000
        });
      }
    },
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.$set(this, 'dateReport', [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()]);
      this.title = this.dataModel.label;
      this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
        let dataUpdate = {}
        if(f.key == 'active'){
          dataUpdate['active'] = data[f.key]
        }
        let variables = {
          'data_update': dataUpdate,
          'where_key': {
            'id': {'_eq': data.id}
          }
        };
        this.$apollo.mutate({
          mutation: DataServices.updateData(this.modelName),
          variables: variables
        }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    getRowActions() {
      var actions = {}
      return actions
    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields();
      var attributes = [];
      for (let index = 0; index < fields.length; index++) {
        const element = fields[index];
        if (element.models !== undefined && element.models !== null) {
          var optionsData = [];
          attributes.push(element.models.key.key);
          attributes.push(element.models.display_key);
          var where_ = {}
          if( element['name']== "name_parent"){
            where_ =  {
              deleted: {'_eq': false},
              parent_id : {'_is_null' : true}
            }
            element.models.tableName = 'category'
          }
          var {data} = await this.$apollo.query({
            query: DataServices.getList(element.models.tableName, {"fields" : attributes.join(',')}),
            variables: {where_key : where_}
          })
          if (data) {
            var result = data[Object.keys(data)];
            if (result) {
              for (let index = 0; index < result.length; index++) {
                const ele = result[index];
                optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
              }
            }
          }
          // console.log("optionsData",optionsData)
          this.options[element.key] = optionsData;
        }
        this.componentKey++;
      }

    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString() }  })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async deleteData() {
      this.showDeleteDialog = false
      if(this.dataDelete.category_parent == null){
        // check có danh mục con không
        var checkDelet = await this.checkParentCategory(this.deleteId)
        if(checkDelet){
          this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Vui lòng xóa danh mục con trước!', life: 3000 })
          return
        }
      }
      var query = DataServices.updateData(this.modelName)
      var variables = {
        'data_update': {
          'deleted': true
        },
        where_key: {
          id: {'_eq': this.deleteId}
        }
      }
      await this.$apollo.mutate({
        mutation: query,
        variables: variables
      }).then(async (res) => {
        // console.log("res.data.",res.data)
        if (res.data.update_category.affected_rows > 0) {
          var querydelproduct = DataServices.deleteData('record_category')
          var variables_product = {
            where_key: {
              "category_id" :{'_eq' : this.deleteId}
            }
          }
          await this.$apollo.mutate({
            mutation: querydelproduct,
            variables: variables_product
          }).then( () => {})

          this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        } else this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Xóa dữ liệu thất bại', life: 3000 })
        this.$apollo.queries.listData.refresh()
      })
    },
    async checkParentCategory(ParentID){
      var {data} = await this.$apollo.query({
          query: DataServices.getList('category'),
          variables: {
          where_key: {
            parent_id: {'_eq': ParentID},
            deleted : {'_eq' : false}
          }
        },
          fetchPolicy: "network-only"
        })
        return data && data[Object.keys(data)].length > 0
    }
  },
  apollo: {
    listData: {
      query() {
        this.modelName = this.$route.meta.model;
        return DataServices.getList(this.modelName);
      },
      variables () {
        // Use vue reactive properties here
        return this.whereKeyList;
      },
      update(data) {
        var listData = data[this.dataModel.tableName]
        this.title = this.dataModel.label + ' '
        this.dataModel.processData(listData)
        this.$store.commit('setLoading', false);
        this.componentKey += 1;
        return data[this.dataModel.tableName]
      },
      fetchPolicy: 'network-only',
      error() {
        this.$store.commit('setLoading', false);
      },
      skip() {
        return !this.modelName
      }
    }
  }

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
</style>